// ------------------------------------------ UTILS
import { FhsAuthInterceptors } from "./auth_interceptors";
import axios from "axios";
import config from "../../../config";
// ------------------------------------------ MODULES

export const FhsAuthAxios = axios.create({
  baseURL: config.baseUrl + config.apiVersion,
  headers: {
    "Content-type": "application/json",
    apiKey: config.apiKey
  }
});

FhsAuthAxios.interceptors.request.use(
  FhsAuthInterceptors.onRequest,
  FhsAuthInterceptors.onError
);

FhsAuthAxios.interceptors.response.use(
  FhsAuthInterceptors.onResponse,
  FhsAuthInterceptors.onError
);
